fetch('/products/filter_database.json')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(databaseOne => {
    fetch('/products/filter_database2.json')
    .then(responseTwo => {
      if (!responseTwo.ok) {
        throw new Error('Network responseTwo was not ok');
      }
      return responseTwo.json();
    }).then(databaseTwo => {

    const collectionDataOne = JSON.parse(databaseOne.product['body_html'])
    const collectionDataTwo = JSON.parse(databaseTwo.product['body_html'])


    const objArray = [collectionDataOne, collectionDataTwo]
    const collectionData = {}

    objArray.map(currentObj => {
      Object.keys(currentObj).map((makeKey) => {
        if(collectionData.hasOwnProperty(makeKey)){
         Object.keys(currentObj[makeKey]).map((yearKey) => {
          if(collectionData[makeKey].hasOwnProperty(yearKey)){
            collectionData[makeKey][yearKey].name = [...collectionData[makeKey][yearKey].name ,...currentObj[makeKey][yearKey].name]
            collectionData[makeKey][yearKey].url = [...collectionData[makeKey][yearKey].url ,...currentObj[makeKey][yearKey].url]
          }else{
            collectionData[makeKey][yearKey] = currentObj[makeKey][yearKey]
          }
        })
        }else{
          collectionData[makeKey] = currentObj[makeKey]
        }
      })
      
    })
      
    console.log('collectionData', collectionData)

    const sectionId = document.getElementsByClassName("section-collections-filter__section")[0].id
    
    const makeSelector = document.getElementById(`make-selector-${sectionId}`)
    const yearSelector = document.getElementById(`year-selector-${sectionId}`)
    const modelSelector = document.getElementById(`model-selector-${sectionId}`)
    const inputSubmit = document.getElementById(`collection-filters-submit-${sectionId}`)
    
    let collectionURL = ''
    const routesCollection = document.getElementsByClassName("section-collections-filter__section")[0].getAttribute('data-routes-collection')
    
    makeSelector.addEventListener("change", function() {
      handleMakeSelection(makeSelector.value)
    });
    
    yearSelector.addEventListener("change", function() {
      handleYearSelection(yearSelector.value)
    });
    
    modelSelector.addEventListener("change", function() {
      handleModelSelection(modelSelector.value)
    });
    
    inputSubmit.addEventListener("click", function() {
      handleCollectionFormSubmit()
    });
    
    const makeValues = Object.keys(collectionData).sort()
    let makeOptions = '<option value="Make...">Make...</option>'
    makeValues.map((value) => makeOptions += `<option value='${value}'>` + value + "</option>")
    
    makeSelector.innerHTML = makeOptions
    
    if (window.localStorage.getItem("shopify-collection-filter-user-preference") !== null) {
      const savedUserPreference = window.localStorage.getItem("shopify-collection-filter-user-preference").split(',')
    
      const yearValues = Object.keys(collectionData[savedUserPreference[0]]).sort().reverse()
      let yearOptions = '<option value="Year...">Year...</option>'
      yearValues.map((value) => yearOptions += `<option value='${value}'>` + value + "</option>")
    
      yearSelector.innerHTML = yearOptions
    
      const modelValues = [...collectionData[savedUserPreference[0]][savedUserPreference[1]].name].sort()
      let modelOptions = '<option value="Model...">Model...</option>'
      modelValues.map((value) => modelOptions += `<option value='${value}'>` + value + "</option>")
    
      modelSelector.innerHTML = modelOptions
    
      makeSelector.value = savedUserPreference[0]
      yearSelector.value = savedUserPreference[1]
      modelSelector.value = savedUserPreference[2]
    
      const urlPosition = collectionData[makeSelector.value][yearSelector.value].name.indexOf(modelSelector.value)
      collectionURL = collectionData[makeSelector.value][yearSelector.value].url[urlPosition]
    
      changeDOMSelectState(yearSelector, 'selector-enabled')
      changeDOMSelectState(modelSelector, 'selector-enabled')
      changeDOMSelectState(inputSubmit, 'button-enabled')
    }

    function changeDOMSelectState(selector, status){
      switch(status){
        case 'selector-disabled':
          selector.setAttribute("disabled", "disabled");
          selector.selectedIndex = 0;
          !selector.parentNode.classList.contains('disabled') && selector.parentNode.classList.add('disabled');
          break;
        case 'selector-enabled':
          selector.removeAttribute("disabled");
          selector.parentNode.classList.remove('disabled');
          break;
        case 'button-enabled':
          selector.removeAttribute("disabled");
          selector.classList.remove('section-collections-filter__button-disabled');
          break;
        case 'button-disabled':
          selector.setAttribute("disabled", "disabled");
          !selector.classList.contains('section-collections-filter__button-disabled') && selector.classList.add('section-collections-filter__button-disabled');
          break;
      }
    }
    
    function handleMakeSelection(make){
      if(make === 'Make...'){
        changeDOMSelectState(yearSelector, 'selector-disabled')
        changeDOMSelectState(modelSelector, 'selector-disabled')
        changeDOMSelectState(inputSubmit, 'button-disabled')
      }else{
        const yearValues = Object.keys(collectionData[make]).sort().reverse()
        let yearOptions = '<option value="Year...">Year...</option>'
        yearValues.map((value) => yearOptions += `<option value='${value}'>` + value + "</option>")
    
        yearSelector.innerHTML = yearOptions
        modelSelector.innerHTML = '<option value="Model...">Model...</option>'
        
        changeDOMSelectState(yearSelector, 'selector-enabled')
        changeDOMSelectState(modelSelector, 'selector-disabled')
      }
    }
    
    function handleYearSelection(year){
      if(year === 'Year...'){
        changeDOMSelectState(modelSelector, 'selector-disabled')
        changeDOMSelectState(inputSubmit, 'button-disabled')
      }else{
        const modelValues = [...collectionData[makeSelector.value][year].name].sort()
        let modelOptions = '<option value="Model...">Model...</option>'
        modelValues.map((value) => modelOptions += `<option value='${value}'>` + value + "</option>")
        
        modelSelector.innerHTML = modelOptions
        changeDOMSelectState(modelSelector, 'selector-enabled')
        
      }
    }
    
    function handleModelSelection(model){
       if(model === 'Model...'){
        changeDOMSelectState(inputSubmit, 'button-disabled')
      }else{
         const urlPosition = collectionData[makeSelector.value][yearSelector.value].name.indexOf(modelSelector.value)
         collectionURL = collectionData[makeSelector.value][yearSelector.value].url[urlPosition]
         changeDOMSelectState(inputSubmit, 'button-enabled')
      }
    }
    
    function handleCollectionFormSubmit(){
      window.localStorage.setItem('shopify-collection-filter-user-preference', `${makeSelector.value},${yearSelector.value},${modelSelector.value}`);
      window.location.href = `${routesCollection}/${collectionURL}`;
    }
      
    }).catch(error => {
    // Handle any errors here
      console.log('Error fetching data from filter_database2:', error);
    });
  })
  .catch(error => {
    // Handle any errors here
    console.log('Error fetching data from filter_database:', error);
  });

